import React, { useEffect } from "react";
import { persistSessionTokens } from "../utils/session";

// Landing point for a cross-subdomain tenant switch: Login.js / SelectTenantPage.js
// / useTenantSwitcher.js redirect the whole browser here (a real navigation, not
// React Router) when the tenant the user picked lives on a different subdomain
// than the one they're currently on. The session tokens travel in the URL
// fragment (never sent to the server or logged, unlike a query string) and are
// stripped immediately on arrival. This is a bounce page, not a destination —
// no ProtectedRoute guard, since the fragment itself is the auth.
const CrossLoginBridge = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const data = {
      token: params.get("token"),
      refreshToken: params.get("refreshToken"),
      email: params.get("email"),
      roles: params.get("roles"),
      id: params.get("userId"),
      hubspot_user_id: params.get("hubspotUserId"),
      activeTenantId: params.get("activeTenantId"),
      isSuperAdmin: params.get("isSuperAdmin") === "true",
    };

    // Strip the fragment before doing anything else so the tokens never sit
    // in browser history, even if persistSessionTokens/navigation below fails.
    window.history.replaceState(null, "", window.location.pathname);

    if (!data.token) {
      window.location.replace("/login");
      return;
    }

    persistSessionTokens(data);
    window.location.replace("/dashboard");
  }, []);

  return (
    <div className="bg-canvas-primary h-screen">
      <div className="mainContainer flex flex-col justify-center items-center w-full h-full py-12 lg:py-24">
        <div className="bg-canvas-white py-11 px-5 flex flex-col items-center rounded-3xl w-[350px]">
          <p className="text-canvas-secondery text-[11.25px]">Switching workspace…</p>
        </div>
      </div>
    </div>
  );
};

export default CrossLoginBridge;
